export const adminAttendeeStatuses = ['checked-in', 'registered', 'canceled'];

export type AdminAttendeeStatusType = (typeof adminAttendeeStatuses)[number];
